import script from "./addemo.vue?vue&type=script&setup=true&lang=js"
export * from "./addemo.vue?vue&type=script&setup=true&lang=js"

import "./addemo.vue?vue&type=style&index=0&id=7587cdbc&lang=less"

const __exports__ = script;

export default __exports__